import { Component, Input, Output, EventEmitter } from '@angular/core';
import { Service } from './adhoc-backup.service';
import { TranslateService, TranslatePipe, LangChangeEvent } from '@ngx-translate/core';
import { GlobalVariables } from '../../../../../common/global-variables';
import { NgForm } from '@angular/forms';

@Component({
  selector: 'adhoc-backup',
  providers: [
    Service, TranslateService
  ],
  styles: [require('./adhoc-backup.scss')],
  template: require('./adhoc-backup.html')
})

export class AdhocBackup {
  @Input('isVisible') isVisible: boolean;
  @Input('selectedObject') selectedObject;
  @Input('selectedVDC') selectedVDC;
  @Input('retentionPeriod') retentionPeriod;
  @Output('onClose') selfClose = new EventEmitter();

  private subscribeHandler;
  private submitted: boolean = false;
  private active: boolean = true;
  private isRequestPending: boolean = false;

  constructor(public service: Service, private translate: TranslateService) {
    translate.use(GlobalVariables.LOCALE);
  }

  onSubmit(f: NgForm) {
    if(f.valid && f.value) {
      this.runAdhocBackup(f.value);
    }
  }

  onSubmitButtonClicked(f: NgForm) {
  }

  onCancelButtonClicked() {
    this.closeSelf();
  }

  //Life Cycle Hooks
  ngOnInit() {
  }

  ngOnChanges(changes) {
  }

  ngAfterViewInit() {
  }

  ngOnDestroy() {
    if(this.subscribeHandler) this.subscribeHandler.unsubscribe();
  }

  runAdhocBackup(formValue) {
    if(formValue && formValue.retention && this.selectedVDC && this.selectedVDC.id !== '' &&
       this.selectedObject && this.selectedObject[0] && this.selectedObject[0].id && this.selectedObject[0].id !== '') {
         let retentionObj = {'retention': {'days': formValue.retention }};
          this.isRequestPending = true;
          this.subscribeHandler = this.service.runAdhocBackup(this.selectedVDC.id, this.selectedObject[0].id, retentionObj)
            .subscribe(
              res => {
                this.reset();
                this.closeSelf();
              },
              error => this.logError(error, 'run Adhoc Backup'),
              () => this.logOperationCompleted('run Adhoc Backup')
            );
    }
    else
      this.logError('Incorrect VDC or vApp information');
  }

  closeSelf() {
    if (this.selfClose) {
      this.selfClose.emit({
        value: "close"
      });
    }
  }

  reset() {
    this.active = false;
    setTimeout(() => this.active = true, 0);
    this.retentionPeriod = null;
  }


  logError(error, origin:String = '') {
    console.error('Error: ', error, (origin !== '')? " Error from " + origin : "");
    this.isRequestPending = false;
  }

  logOperationCompleted(msg: string) {
    console.log('Operation Completed: ', msg)
    this.isRequestPending = false;
  }
}



// WEBPACK FOOTER //
// ./src/app/components/dataprotection/dataprotection-vcd/adhoc-backup/adhoc-backup.component.ts